import { Component, inject, signal } from '@angular/core';
import { LvrButton } from '../../../core/components/lvr-button/lvr-button';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { User } from '../../../api/app-types/user.app';
import { USER_SERVICE, UserApi } from '../../../api/services/user.service';
import { NOTIFICATION_SERVICE } from '../../../shared/notification/notification';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { createErrorNotification, createSuccessNotification } from '../../../shared/notification/notification.factory';

@Component({
	selector: 'lvr-user-reactive-dialog',
	template: `
		<h2 mat-dialog-title>{{ 'user.reactivate.title' | transloco }}</h2>
		<mat-dialog-content>
			<p>
				{{ 'user.reactivate.confirmation' | transloco: { firstName: user.firstName, lastName: user.lastName } }}
			</p>
		</mat-dialog-content>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'user.reactivate.cancel' | transloco"
				[type]="'button'"
				[disabled]="loading()"
				icon="disabled_by_default"
				mat-dialog-close
			></lvr-button>
			<lvr-button
				variant="primary"
				[label]="'user.reactivate.reactivate' | transloco"
				[type]="'button'"
				[disabled]="loading()"
				[loading]="loading()"
				[loadingLabel]="'user.reactivate.reactivating' | transloco"
				(clicked)="reactivateUser()"
				icon="how_to_reg"
			></lvr-button>
		</mat-dialog-actions>
	`,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	providers: [{ provide: USER_SERVICE, useClass: UserApi }],
})
export class UserReactivateDialog {
	public readonly user: User = inject(MAT_DIALOG_DATA);
	private readonly dialogRef = inject(MatDialogRef<UserReactivateDialog>);
	private readonly userService = inject(USER_SERVICE);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly transloco = inject(TranslocoService);
	public readonly loading = signal(false);

	public async reactivateUser() {
		if (this.loading()) return;

		this.loading.set(true);

		try {
			await this.userService.reactivateUser(this.user.objectId);

			this.ntfySrv.addNotification(
				createSuccessNotification(
					this.transloco.translate('base.notification_message.user_reactivate_success', {
						firstName: this.user.firstName,
						lastName: this.user.lastName,
					}),
				),
			);
			this.dialogRef.close(true);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (_: unknown) {
			this.ntfySrv.addNotification(
				createErrorNotification(this.transloco.translate('base.notification_message.user_reactivate_error')),
			);
		} finally {
			this.loading.set(false);
		}
	}
}
